$( document ).ready(function() {
  
  var c_slider_hor=getCookie('slider_hor');
  var c_slider_ver=getCookie('slider_ver');
  
  if(c_slider_hor!=""){
    var start_width = c_slider_hor;
  } else {
    var start_width = 4;
  }
  
  if(c_slider_ver!=""){
    var start_height =c_slider_ver;
  } else {
    var start_height =4;
  }

  function initslider(slider){
    var cookie=getCookie(slider);
    
  }

  var settings_max_width = 25;
  var settings_max_height = 30;
  var step_size=10;
  var start_text = start_width+'x'+start_height;

  //slider  functions
   /*function to calculate the inverse of the vertical slider */
  function calcInvVert(input){
    var max_vert = settings_max_height;
    var output = max_vert-input+1;
    return output;
  }
  
  /*function for horizontal slider */
  $( "#slider-range-hor" ).slider({
    range: "max",
    min: 1,
    max: settings_max_width,
    value: start_width,
    slide: function( event, ui ) {
      $("#size-hor-cm").val( ui.value*step_size );
      $( "#size-hor" ).html( ui.value*step_size );
      updateBG(ui.value,calcInvVert($( "#slider-vertical" ).slider( "value" )));
    }
  });
  
 

  /*fnction for vertical slider */
  $( "#slider-vertical" ).slider({
    orientation: "vertical",
    range: "min",
    min: 1,
    max: settings_max_height,
    value: calcInvVert(start_height),
    slide: function( event, ui ) {
      $('#size-ver-cm').val( calcInvVert(ui.value)*step_size );
      $( "#size-vert" ).html( calcInvVert(ui.value)*step_size );
      updateBG($( "#slider-range-hor" ).slider( "value" ),calcInvVert(ui.value));
    }
  });
  
  //init values
  $( "#size-hor" ).html( $( "#slider-range-hor" ).slider( "value" )*step_size );
  $( "#size-vert" ).html( calcInvVert($( "#slider-vertical" ).slider( "value" ))*step_size);
  updateBG(start_width,start_height);
 
  //update function
  /*function to update the background on the slider */ 
  function updateBG(hor,ver){
    var clr_on=	'var(--header-accent-color)';
    var clr_off='';
    //alert('Hor: '+hor+' - Ver: '+ver);
    var hor_max=settings_max_width;
    var ver_max=settings_max_height;
    
    setCookie('slider_hor',hor);
    setCookie('slider_ver',ver);

    var setId='';
    for(let i=1;i<=hor_max;i++){
      for(let j=1;j<=ver_max;j++){
        setId = '#row'+j+'col'+i;

        if(i<=hor && j<=ver){
          $(setId).css('background-color', clr_on);
        } else {
          $(setId).css('background-color', clr_off);
        }
      }
    }
  }
});

//get the cookie
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
